import { capitalize } from "lodash"
import { INSTRUMENTS } from "connected-components/dashboard/helpers"
import { DESC } from "helpers/sorts"

export const EMPTY_ARRAY = []

export function resolveCustomDefaultSort(
  filteredMetrics: { id: string, downloadOnly?: boolean }[],
  instrumentColumns: string[],
) {
  const sortableMetrics = filteredMetrics.filter((metric) => !metric.downloadOnly)
  const primaryColumn = instrumentColumns[0] as keyof typeof INSTRUMENTS | undefined
  const defaultSortSuffix = primaryColumn != null ? (INSTRUMENTS[primaryColumn]?.suffix ?? "") : ""
  const marketValueSortPath = `marketValue${capitalize(defaultSortSuffix)}`
  const hasMarketValueColumn = sortableMetrics.some((metric) => metric.id === marketValueSortPath)
  const sortPath = hasMarketValueColumn ? marketValueSortPath : sortableMetrics[0]?.id

  return { path: sortPath ?? "label", direction: DESC }
}
